// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Router from 'vue-router'
import axios from 'axios'
import QS from 'qs'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { post, get } from '@/request/http'
import myStore from '@/pages/Global'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import SvgIcon from '@/components/SvgImg'// 引入上面封装的svg component

// register globally
Vue.component('svg-icon', SvgIcon)

const svgIcons = require.context('@/icons/svg/', false, /\.svg$/)
console.log(svgIcons)
const requireAll = requireContext => requireContext.keys().map(requireContext)
console.log(requireAll)
requireAll(svgIcons)

Vue.prototype.$post = post
Vue.prototype.$get = get

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$qs = QS
Vue.prototype.myStore = myStore;
Vue.use(ElementUi);

Vue.use(Router)
Vue.use(VueQuillEditor, /* { default global options } */)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  Router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js